export default {"src":"https://cdn.comverseglobal.com/alfa/_next/static/media/sendIcon.68cc9a63.svg","height":20,"width":22,"blurWidth":0,"blurHeight":0};